export default __webpack_public_path__ + "assets/images/pancakeswap-icon.png";